import React from 'react'
import { useTranslation } from 'react-i18next';
import '../css/footer.css';

const Footer = () => {
  const { t } = useTranslation(["home"]);
  return (
      <footer>
        <div className="footer">
         <div className="topBox">
          <h1>{t("footer.h1")}</h1>
          <a href="/contact" className="ourService footerBtn">{t("footer.getStarted")}</a>
          <img src={require("../assets/footerAni.gif")} alt="animation" /> 
          </div>
          <div className="mainContent">
            <div className="box1 box">
              <a href="/"><img id='footer-logo' src={require("../assets/Strong-IT-Logo-white.png")} alt="logo" /></a>
              <img src={require("../assets/appleWindow.png")} alt="team" />
              <h2>{t("footer.h2")}</h2>
              <a href="https://download.teamviewer.com/QS" className="quickSupport">{t("footer.quickSupport")}</a>            
            </div>

              <ul className="box box2">
                <li className='headings'>{t("footer.contactUs")}</li>
                <li><a href="tel:+14387787834">438 778 7834</a></li>
                <li><a href="mailto:helpdesk@strongit.ca">helpdesk@strongit.ca</a></li>
                <li><a href="mailto:james@strongit.ca">james@strongit.ca</a></li>
              </ul>
              {/* <ul className="box box3">
                <li className="headings">{t("footer.about")}</li>
                <li><a href="/about#partners">{t("footer.about1")}</a></li>
              </ul> */}
              <ul className="box box4">
                <li className="headings">{t("footer.services")}</li>
                <li><a href="/services#Managed-Services">{t("footer.service1")}</a></li>
                <li><a href="/services#Co-Managed-IT-Services" >{t("footer.service2")}</a></li>
                <li><a href="/services#Project-Services">{t("footer.service3")}</a></li>
                <li><a href="/services#IT-Strategy-Services">{t("footer.service4")}</a></li>
              </ul> 
          </div>        
        </div>
      </footer>
  )
}

export default Footer